<template>
  <div ref="outer" class="outer">
    <div class="relative-container" ref="container" @mousemove="onUpdateRuler">
      <table class="table">
        <tbody>
        <tr v-for="h in hours">
          <td style="width:50px;padding: 1px" class="cell">{{h}}</td>
          <td class="cell"></td>
        </tr>
        </tbody>
      </table>
      <div class="col-container" ref="colContainer">
        <div v-if="ruler.isShowing && !dnd.showDndRect" class="ruler" :style="rulerStyle"></div>
        <div v-if="ruler.isShowing && !dnd.showDndRect" class="ruler-text" :style="rulerTextStyle">
          {{ruler.time}}
        </div>

        <div v-if="dnd.showDndRect" class="dnd-rect" :class="{'dnd-rect-error':dnd.isError}" :style="dndStyle">
          <span>{{dnd.start.time}} - {{dnd.end.time}}</span>
        </div>

        <div v-for="(weekday,index) in weekTitles" class="col"
             :style="{width:'calc((100% - 70px) / '+weekTitles.length+')'}">
          <div class="week-title">
            {{weekday.title}}
          </div>
          <div class="week-col" :data-key="weekday.key" :data-index="index" @mousedown="onMouseDown">
            <div v-for="item in items[weekday.key]"
                 class="item"
                 :class="getItemClass(item)"
                 :style="getItemStyle(item)"
                 @mousedown="itemDragStart($event,item,items[weekday.key],weekday.key)"
            >
              <div class="flex-row">
                <span class="item-time">
                  {{item.startTime}} - {{item.endTime}}
                </span>
                <div class="ui tiny icon button del-btn" @click="onItemRemove(item,items[weekday.key])">
                  <i class="ui remove icon"></i>
                </div>
              </div>
              <div class="resizer" @mousedown="itemResizeStart($event,item,items[weekday.key],weekday.key)">
                <i class="ui minus icon"></i>
              </div>
              <div v-if="isRightCutterNeeded(item,weekday.key)" class="right-cutter"
                   @click="makeCut($event,item,weekday.key)">
                <div>
                  <i class="ui clockwise rotated cut icon"></i>
                </div>
                <div class="dash-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped>
  .right-cutter {
    transition: opacity 0.3s;
    position: absolute;
    right: -20px;
    float: right;
    display: flex;
    flex-flow: column;
    align-items: center;
    height: calc(100% + 50px);
    width: 39px;
    top: -40px;
    opacity: 0;
  }

  .right-cutter:hover {
    opacity: 1;
  }

  .dash-line {
    flex: 1 1 auto;
    width: 1px;
    border: 1px dashed rgba(0, 0, 0, 0.5);
  }

  .ruler, .ruler-text {
    position: absolute;
    background: lightblue;
  }

  .ruler {
    width: 100%;
    height: 1px;
  }

  .ruler-text {
    border-radius: 4px;
    padding: 4px;
    width: 48px;
    height: 24px;
    margin-top: -24px;
    margin-left: -48px;
    text-align: center;
    font-weight: bolder;
    color: rgba(0, 0, 0, .5);
  }

  .flex-row {
    display: flex;
    flex-flow: row;
    align-items: center;
  }

  .item-moving {
    box-shadow: 0 10px 20px 5px #b1b1b1;
  }

  .item.item-resizing, .item.item-moving {
    border-color: #87a5af;
    z-index: 1000;
  }

  .item:hover {
    z-index: 3;
  }

  .resizer {
    transition: opacity .3s;
    position: absolute;
    display: block;
    left: -2px;
    bottom: -19px;
    width: calc(100% + 4px);
    z-index: 2;
    background: #98bdca;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    opacity: 0;
  }

  .resizer:hover {
    opacity: 1;
    cursor: row-resize;
  }

  .item:hover > .flex-row > .del-btn {
    opacity: 1;
  }

  .item.item-error > .resizer {
    background: #9e1317;
  }

  .del-btn {
    opacity: 0;
    transition: opacity .3s;
    color: #575757;
    background: transparent;
    z-index: 3;
  }

  .del-btn:hover {
    background: #91bdcc;
  }

  .item-time {
    flex: 1 1 auto;
    display: block;
    font-weight: bolder;
    padding-left: 32px;
    color: rgba(0, 0, 0, .5);
  }

  .dnd-rect {
    position: absolute;
    border: 2px solid #0d71bb;
    background: #00bcd4;
    opacity: 0.6;
  }

  .dnd-rect-error, .item.item-error {
    border: 2px solid #9e1317;
    background: #ff5252;
  }

  .outer {
    width: 100%;
    height: 100%;
  }

  .week-col {
    height: calc(100% - 50px);
    position: relative;
    left: 0;
    width: 100%;
    overflow: hidden;
    border-left: 1px solid #e0e0e0;
  }

  .item {
    transition: box-shadow 0.1s;
    cursor: pointer;
    border: 2px solid transparent;
    position: absolute;
    width: 100%;
    background: lightblue;
    opacity: 0.9;
    z-index: 1;
  }

  .relative-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .col-container {
    position: absolute;
    top: 0;
    left: 50px;
    display: inline-flex;
    align-items: stretch;
    width: calc(100% - 50px);
    height: 100%;
  }

  .col {
    text-align: center;
    flex: 1 1 auto;
  }

  .week-title {
    padding: 0.8em 0;
    font-size: 18px;
    height: 50px;
    background: rgba(0, 0, 0, .02);
  }

  .table {
    /*z-index: -1;*/
    width: 100%;
    height: calc(100% - 50px);
    position: absolute;
    top: 50px;
    left: 0;
  }

  .cell {
    height: calc((100% - 50px) / 24);
    vertical-align: top;
    text-align: center;
    font-size: 0.8em;
    color: rgba(0, 0, 0, 0.7);
  }

</style>
<script>
  import timeConvertMixin from "./time-convert-mixin"

  import 'element-closest'

  import {values} from 'lodash'

  export default {
    name: "vue-work-week-calendar",

    mixins: [timeConvertMixin],
    props: {
      weekTitles: {
        type: Array,
        default() {
          return [
            {
              title: 'Понедельник',
              key: 'mon'
            },
            {
              title: 'Вторник',
              key: 'tue'
            },
            {
              title: 'Среда',
              key: 'wed'
            },
            {
              title: 'Четверг',
              key: 'thr'
            },
            {
              title: 'Пятница',
              key: 'fri'
            },
            {
              title: 'Суббота',
              key: 'sat'
            },
            {
              title: 'Воскресенье',
              key: 'sun'
            }];
        }
      },
      items: {
        type: Object,
        default() {
          return {
            mon: [],
            tue: [],
            wed: [],
            thr: [],
            fri: [],
            sat: [],
            sun: []
          }
        }
      },
      minItemDuration: {
        type: Number,
        default: 1
      },
      dndSnap: {
        type: Number,
        default: 0.25
      }
    },
    data() {
      return {
        hours: [],
        dnd: {
          start: {
            x: 0,
            y: 0,
            elem: null,
            time: ""
          },
          end: {
            x: 0,
            y: 0,
            elem: null,
            time: ""
          },
          showDndRect: false,
          isError: false,
        },
        itemMoving: {
          weekday: null,
          elem: null,
          item: null,
          items: null,
          itemsKey: null,
          offsetY: 0,
          isError: false,
          prevStart: null,
          prevEnd: null,
          prevItems: null,
          linked: null,
        },
        itemResizing: {
          elem: null,
          weekday: null,
          item: null,
          items: null,
          itemsKey: null,
          prevEnd: null,
          isError: false,
          linked: null,
          offsetY: 0
        },
        ruler: {
          time: "",
          isShowing: false,
          top: 0,
          left: 0
        },
        linkedItems: [],
        keysOrder: {}
      }
    },
    created: function () {

      for (let i = 0; i < 24; i++) {
        let time = i < 10 ? '0' + i + ':00' : i + ':00';
        this.hours.push(time);
      }
      for (let i = 0; i < this.weekTitles.length; i++) {
        this.keysOrder[this.weekTitles[i].key] = i;
      }
    },
    mounted() {
      this.weekTitles.forEach(weekTitle => {
        if (!this.items[weekTitle.key]) this.items[weekTitle.key] = []
      });
    },

    methods: {

      getItemStyle(item) {
        let splitStart = item.startTime.split(":");
        let startMins = Number.parseInt(splitStart[0]) * 60 + Number.parseInt(splitStart[1]);
        let splitEnd = item.endTime.split(":");
        let endMins = Number.parseInt(splitEnd[0]) * 60 + Number.parseInt(splitEnd[1]);

        let diff = endMins - startMins;
        let minutesInDay = 24 * 60;
        let height = 100 * diff / minutesInDay + "%";
        let top = 100 * startMins / minutesInDay + "%";

        return {height, top}
      },
      getItemClass(item) {
        return {
          'item-error': this.isItemError(item),
          'item-moving': this.itemMoving.item == item
            || (this.itemMoving.linked && values(this.itemMoving.linked).indexOf(item) > -1),
          'item-resizing': this.itemResizing.item == item
            || (this.itemResizing.linked && values(this.itemResizing.linked).indexOf(item) > -1)
        }
      },
      snapY(containerHeight, containerTop, toSnap, snap) {
        let offset = containerTop;
        let delta = toSnap - offset;
        let snapInPixels = snap / 24 * containerHeight;
        let snappedDelta = Math.round(delta / snapInPixels) * snapInPixels;
        let snappedY = offset + snappedDelta;
        return snappedY;
      },
      /*----------обработчики создания элементов-----------*/
      onMouseDown(e) {

        let target = e.target.closest('.week-col');
        let rect = target.getBoundingClientRect();

        this.dnd.start.elem = target;
        this.dnd.start.x = rect.left;
        if (this.dndSnap > 0) {
          this.dnd.start.y = this.dnd.end.y = this.snapY(rect.height, rect.top, e.clientY, this.dndSnap);
        } else {
          this.dnd.start.y = this.dnd.end.y = e.clientY;
        }
        this.dnd.end.elem = target;
        this.dnd.end.x = rect.right;


        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
        this.dnd.showDndRect = true;
        e.preventDefault();
      },
      onMouseMove(e) {
        e.preventDefault();
        let endTarget = e.target.closest('.week-col');
        this.dnd.end.y = Math.max(e.clientY, this.dnd.start.y);
        if (this.dndSnap > 0) {
          let rect = this.dnd.start.elem.getBoundingClientRect();
          this.dnd.end.y = this.snapY(rect.height, rect.top, this.dnd.end.y, this.dndSnap);
        }
        if (!endTarget) {
          return;
        }
        let startTarget = this.dnd.start.elem;
        let startIdx = +startTarget.getAttribute("data-index");
        let endIdx = +endTarget.getAttribute("data-index");
        this.dnd.end.elem = endTarget;
        let endRect = endTarget.getBoundingClientRect();
        let startRect = startTarget.getBoundingClientRect();
        if (startIdx < endIdx) {
          this.dnd.end.x = endRect.right;
        } else if (startIdx > endIdx) {
          this.dnd.start.x = endRect.left;
          this.dnd.end.x = startRect.right;
        } else {
          this.dnd.start.x = startRect.left;
          this.dnd.end.x = startRect.right;
        }
        this.dnd.end.elem = endTarget;

        let rect = this.dnd.start.elem.getBoundingClientRect();
        let durationInHours = 24 * (this.dnd.end.y - this.dnd.start.y) / rect.height;


        //CHECK OVERLAPS
        let minIdx = Math.min(startIdx, endIdx);
        let maxIdx = Math.max(startIdx, endIdx);

        let overlapedItems = [...document.querySelectorAll(".week-col")].filter(elem => elem.getAttribute("data-index") >= minIdx && elem.getAttribute("data-index") <= maxIdx);

        let startInHours = 24 * (this.dnd.start.y - rect.top) / rect.height;
        let endInHours = startInHours + durationInHours;

        this.dnd.start.time = this.convertHoursToString(startInHours);
        this.dnd.end.time = this.convertHoursToString(endInHours);

        this.dnd.isError = false;

        for (let i = 0; i < overlapedItems.length; i++) {
          let item = overlapedItems[i];
          let key = item.getAttribute("data-key");
          for (let j = 0; j < this.items[key].length; j++) {
            let elem = this.items[key][j];
            let elemStartSplit = elem.startTime.split(":");
            let elemEndSplit = elem.endTime.split(":");
            let elemStartInHours = +elemStartSplit[0] + (elemStartSplit[1] / 60);
            let elemEndInHours = +elemEndSplit[0] + (elemEndSplit[1] / 60);

            if (!(endInHours <= elemStartInHours || elemEndInHours <= startInHours)) {
              this.dnd.isError = true;
              break;
            }
          }
        }
        if (durationInHours < this.minItemDuration) {
          this.dnd.isError = true;
        }


      },
      onMouseUp(e) {
        this.dnd.showDndRect = false;
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        e.preventDefault();

        if (e.button != 0 || this.dnd.isError) {
          e.stopPropagation();
          return;//Если нажата не левая кнопка мыши то отменяем ФСЁ
        }

        let startIdx = +this.dnd.start.elem.getAttribute("data-index");
        let endIdx = +this.dnd.end.elem.getAttribute("data-index");

        let minIdx = Math.min(startIdx, endIdx);
        let maxIdx = Math.max(startIdx, endIdx);

        let overlapedItems = [...document.querySelectorAll(".week-col")].filter(elem => elem.getAttribute("data-index") >= minIdx && elem.getAttribute("data-index") <= maxIdx);

        let rect = this.dnd.start.elem.getBoundingClientRect();

        let durationInHours = 24 * (this.dnd.end.y - this.dnd.start.y) / rect.height;
        let startInHours = 24 * (this.dnd.start.y - rect.top) / rect.height;
        let endInHours = startInHours + durationInHours;

        let startTime = this.convertHoursToString(startInHours);
        let endTime = this.convertHoursToString(endInHours);

        let event = {};
        for (let i = 0; i < overlapedItems.length; i++) {
          let item = overlapedItems[i];
          let key = item.getAttribute("data-key");
          let newElem = {startTime, endTime};
          event[key] = newElem;
          this.items[key].push(newElem);
        }
        this.$emit("onItemAdd", event);
        if (overlapedItems.length > 1) {
          this.linkedItems.push(event);
        }
      },
      /*----------------удаление элемента------------------*/
      onItemRemove(item, items) {
        let linked = this.findLinked(item);
        if (linked) {
          let keys = Object.keys(linked);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let item = linked[key];
            let items = this.items[key];
            for (let j = items.length - 1; j >= 0; j--) {
              if (items[j] == item) {
                items.splice(j, 1);
                break;
              }
            }
          }
        } else {
          for (let i = items.length - 1; i >= 0; i--) { // проходим в обратном порядке, чтобы избежать ошибок при удалении
            if (items[i] == item || (item.id && item.id == items[i].id)) {
              let removed = items.splice(i, 1);//удаляем элемент
              this.$emit("onItemRemove", removed);
              break;
            }
          }
        }
      },
      /*---------перемещение элемента вверх/вниз-----------*/
      itemDragStart(e, item, items, key) {
        e.preventDefault();
        e.stopPropagation();
        this.itemMoving.item = item;
        this.itemMoving.items = items;
        this.itemMoving.elem = e.target.closest('.item');
        this.itemMoving.weekday = e.target.closest('.week-col');
        this.itemMoving.itemsKey = key;

        let rect = this.itemMoving.elem.getBoundingClientRect();
        this.itemMoving.offsetY = e.clientY - rect.top;
        this.itemMoving.prevStart = item.startTime;
        this.itemMoving.prevEnd = item.endTime;
        this.itemMoving.prevItems = items;
        this.itemMoving.linked = this.findLinked(item);

        window.addEventListener("mousemove", this.itemIsMoving);
        window.addEventListener("mouseup", this.itemDragFinished);

      },
      itemIsMoving(e) {
        e.preventDefault();
        e.stopPropagation();

        let y = e.clientY - this.itemMoving.offsetY;
        let weekDayRect = this.itemMoving.weekday.getBoundingClientRect();
        let elemRect = this.itemMoving.elem.getBoundingClientRect();
        if (y < weekDayRect.top) y = weekDayRect.top;

        let newStartInHours = 24 * (y - weekDayRect.top) / weekDayRect.height;
        let durationInHours = 24 * elemRect.height / weekDayRect.height;
        let newEndInHours = newStartInHours + durationInHours;

        if (this.dndSnap > 0) {
          newStartInHours = Math.round(newStartInHours / this.dndSnap) * this.dndSnap;
          newEndInHours = Math.round(newEndInHours / this.dndSnap) * this.dndSnap;
        }

        if (newEndInHours > 24) {
          newEndInHours = 24;
          newStartInHours = 24 - durationInHours;
        }

        let newStart = this.convertHoursToString(newStartInHours);
        let newEnd = this.convertHoursToString(newEndInHours);
        this.itemMoving.item.startTime = newStart;
        this.itemMoving.item.endTime = newEnd;

        if (this.itemMoving.linked) {
          let vals = values(this.itemMoving.linked);
          for (let i = 0; i < vals.length; i++) {
            let linkedItem = vals[i];
            linkedItem.startTime = newStart;
            linkedItem.endTime = newEnd;
          }
        }

        this.itemMoving.isError = false;
        if (this.itemMoving.linked) {
          let keys = Object.keys(this.itemMoving.linked);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let items = this.items[key];
            let item = this.itemMoving.linked[key];
            for (let j = 0; j < items.length; j++) {
              let curItem = items[j];
              if (curItem != item && !(item.endTime <= curItem.startTime || curItem.endTime <= item.startTime)) {
                this.itemMoving.isError = true;
                break;
              }
            }
            if (this.itemMoving.isError) {
              break;
            }
          }
        } else {
          for (let i = 0; i < this.itemMoving.items.length; i++) {
            let currentItem = this.itemMoving.items[i];
            if (currentItem != this.itemMoving.item) {
              let curItemStartInHours = this.convertStringToHours(currentItem.startTime);
              let curItemEndInHours = this.convertStringToHours(currentItem.endTime);

              if (!(newEndInHours <= curItemStartInHours || curItemEndInHours <= newStartInHours)) {
                this.itemMoving.isError = true;
                break;
              }
            }
          }
        }
      },
      itemDragFinished(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.itemMoving.isError) {
          this.itemMoving.item.startTime = this.itemMoving.prevStart;
          this.itemMoving.item.endTime = this.itemMoving.prevEnd;
          if (this.itemMoving.linked) {
            let vals = values(this.itemMoving.linked);
            for (let i = 0; i < vals.length; i++) {
              let linkedItem = vals[i];
              linkedItem.startTime = this.itemMoving.prevStart;
              linkedItem.endTime = this.itemMoving.prevEnd;
            }
          }
        }
        this.$emit("onItemUpdate", this.itemMoving.linked || {[this.itemMoving.itemsKey]: this.itemMoving.item});
        this.itemMoving.isError = false;
        this.itemMoving.item = null;
        this.itemMoving.linked = null;
        window.removeEventListener("mousemove", this.itemIsMoving);
        window.removeEventListener("mouseup", this.itemDragFinished);
      },
      /*------------изменение размеров элемента------------*/
      itemResizeStart(e, item, items, key) {
        e.stopPropagation();
        e.preventDefault();
        window.addEventListener("mousemove", this.itemIsResizing);
        window.addEventListener("mouseup", this.itemResizeFinished);

        this.itemResizing.item = item;
        this.itemResizing.items = items;
        let itemElem = e.target.closest(".item");
        this.itemResizing.elem = itemElem;
        this.itemResizing.weekday = e.target.closest(".week-col");
        this.itemResizing.prevEnd = item.endTime;
        let rect = itemElem.getBoundingClientRect();
        this.itemResizing.offsetY = (rect.top + rect.height) - e.clientY;
        this.itemResizing.linked = this.findLinked(item);
        this.itemResizing.itemsKey = key;
      },
      itemIsResizing(e) {
        e.stopPropagation();
        e.preventDefault();

        let newY = e.clientY + this.itemResizing.offsetY;
        let elemRect = this.itemResizing.elem.getBoundingClientRect();
        let weekDayRect = this.itemResizing.weekday.getBoundingClientRect();
        let newDurationInHours = 24 * (newY - elemRect.top) / weekDayRect.height;
        if (newDurationInHours < this.minItemDuration) {
          newDurationInHours = this.minItemDuration;
        }
        let startInHours = this.convertStringToHours(this.itemResizing.item.startTime);
        let newEndInHours = startInHours + newDurationInHours;
        if (this.dndSnap > 0) {
          newEndInHours = Math.round(newEndInHours / this.dndSnap) * this.dndSnap;
        }
        let newEnd = this.convertHoursToString(newEndInHours);
        this.itemResizing.item.endTime = newEnd;
        if (this.itemResizing.linked) {
          let vals = values(this.itemResizing.linked);
          for (let i = 0; i < vals.length; i++) {
            let linkedItem = vals[i];
            linkedItem.endTime = newEnd;
          }
        }
        this.itemResizing.isError = false;
        if (this.itemResizing.linked) {
          let keys = Object.keys(this.itemResizing.linked);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let items = this.items[key];
            let item = this.itemResizing.linked[key];
            for (let j = 0; j < items.length; j++) {
              let curItem = items[j];
              if (curItem != item && !(item.endTime <= curItem.startTime || curItem.endTime <= item.startTime)) {
                this.itemResizing.isError = true;
                break;
              }
            }
            if (this.itemResizing.isError) {
              break;
            }
          }
        } else {
          for (let i = 0; i < this.itemResizing.items.length; i++) {
            let curItem = this.itemResizing.items[i];
            if (curItem != this.itemResizing.item) {
              let curItemStartInHours = this.convertStringToHours(curItem.startTime);
              let curItemEndInHours = this.convertStringToHours(curItem.endTime);
              if (!(curItemEndInHours <= startInHours || newEndInHours <= curItemStartInHours)) {
                this.itemResizing.isError = true;
                break;
              }
            }
          }
        }
      },
      itemResizeFinished(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.itemResizing.isError) {
          this.itemResizing.item.endTime = this.itemResizing.prevEnd;
          if (this.itemResizing.linked) {
            let vals = values(this.itemResizing.linked);
            for (let i = 0; i < vals.length; i++) {
              let linkedItem = vals[i];
              linkedItem.endTime = this.itemResizing.prevEnd;
            }
          }
        }
        this.$emit("onItemUpdate", this.itemResizing.linked || {[this.itemResizing.itemsKey]: this.itemResizing.item});
        this.itemResizing.item = null;
        this.itemResizing.linked = null;
        this.itemResizing.isError = false;
        window.removeEventListener("mousemove", this.itemIsResizing);
        window.removeEventListener("mouseup", this.itemResizeFinished);
      },
      /*---------------------------------------------------*/
      isItemError(item) {
        return ((this.itemMoving.item == item
          || (this.itemMoving.linked && values(this.itemMoving.linked).indexOf(item) > -1))
          && this.itemMoving.isError)
          || ((this.itemResizing.item == item
            || (this.itemResizing.linked && values(this.itemResizing.linked).indexOf(item) > -1))
            && this.itemResizing.isError);
      },
      onUpdateRuler(e) {
        //если мышь на свободной области
        if (e.target == e.target.closest('.week-col')) {
          this.ruler.isShowing = true;
          this.ruler.top = e.clientY;
          this.ruler.left = e.clientX;
          let rect = e.target.getBoundingClientRect();
          let timeInHours = 24 * (e.clientY - rect.top) / rect.height;
          this.ruler.time = this.convertHoursToString(timeInHours);
        } else {
          this.ruler.isShowing = false;
        }
      },
      findLinked(item) {
        for (let i = 0; i < this.linkedItems.length; i++) {
          let list = values(this.linkedItems[i]);
          let idx = list.indexOf(item);
          if (idx > -1) {
            return this.linkedItems[i];
          }
        }
        return null;
      },
      isRightCutterNeeded(item, key) {
        let linked = this.findLinked(item);
        if (!linked) {
          return false;
        }
        let itemWeekDayOrder = this.keysOrder[key];
        let maxOrder = Number.MIN_VALUE;
        let self = this;
        Object.keys(linked).forEach(k => {
          let order = self.keysOrder[k];
          if (order > maxOrder)
            maxOrder = order;
        });
        return maxOrder > itemWeekDayOrder;
      },
      makeCut(e, item, key) {
        e.preventDefault();
        e.stopPropagation();
        let linked = this.findLinked(item);
        let newLinked = {};
        let keys = Object.keys(linked);
        let order = this.keysOrder[key];
        let newLength = 0;
        let oldLength = keys.length;
        keys.forEach(k => {
          let korder = this.keysOrder[k];
          if (korder > order) {
            newLinked[k] = linked[k];
            delete linked[k];
            newLength++;
            oldLength--;
          }
        });
        if (newLength > 1) {
          this.linkedItems.push(newLinked);
        }
        if (oldLength < 2) {
          let idx = this.linkedItems.indexOf(linked);
          this.linkedItems.splice(idx, 1);
        }
      }
    },
    computed: {
      dndStyle() {
        const colContainerBoundingClientRect = this.$refs.colContainer.getBoundingClientRect();

        return {
          top: (this.dnd.start.y - colContainerBoundingClientRect.y) + 'px',
          left: (this.dnd.start.x - colContainerBoundingClientRect.x) + 'px',
          width: this.dnd.end.x - this.dnd.start.x + 'px',
          height: this.dnd.end.y - this.dnd.start.y + 'px'
        }

      },
      rulerStyle() {
        return {
          top: (this.ruler.top - this.$refs.colContainer.getBoundingClientRect().y) + 'px'
        }
      },
      rulerTextStyle() {
        const colContainerBoundingClientRect = this.$refs.colContainer.getBoundingClientRect();
        return {
          top: (this.ruler.top - colContainerBoundingClientRect.y) + 'px',
          left: (this.ruler.left - colContainerBoundingClientRect.x) + 'px'
        }
      }
    }


  }
</script>


